<template>
  <FormContainer>
    <template #content>
      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_206"
          v-model="attestationResteChargeContributionModel"
          @update:model-value="() => (modePriseEnChargeResteModel = null)"
          label="En cas de reste à charge sur votre dossier, souhaitez-vous qu’il soit pris en charge ? "
          :required="meta.financement?.attestationResteChargeContribution?.$status === PropertyStatus.Required"
          :alertLabel="meta.financement?.attestationResteChargeContribution?.$messageErreurDirty!"
          :items="OuiOuNon"
          :readonly
          nbMaxLines="2"
          class="col-10 col-md-14 col-sm-36"
        />
        <WrapperDropdown
          id="field_207"
          v-model="modePriseEnChargeResteModel"
          label="Le reste à charge doit être pris sur votre contribution :"
          :required="meta.financement?.modePriseEnChargeReste?.$status === PropertyStatus.Required"
          :alertLabel="meta.financement?.modePriseEnChargeReste?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :items="resteChargeContribution"
          :disabled="!attestationResteChargeContributionModel"
          :readonly
        />
      </div>
      <div class="form__bloc"></div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import {
    ResteChargeContributionTypePublicInterimaire,
    ResteChargeContributionTypePublicInterimaireCDI,
  } from '@/features/domaine/types/opco/Demande/CXPI/ResteChargeContribution'
  import { ResteChargeContributionLibelle } from '@/features/domaine/types/opco/Demande/shared/ResteChargeContribution'
  import { arrayToDropdownItems, OuiOuNon } from '@/features/interface/shared/tools'
  import type { DropdownItem } from '@designSystem/index'
  import { storeToRefs } from 'pinia'
  import { computed } from 'vue'
  import FormContainer from '../../../shared/components/FormContainer.vue'
  import { useFormationDemandeCXPIStore } from '../../useCXPIStore'

  const store = useFormationDemandeCXPIStore()
  const { setupFieldWithKey } = store
  const { readonly, meta, model } = storeToRefs(store)

  const attestationResteChargeContributionModel = setupFieldWithKey<boolean>(
    'financement.attestationResteChargeContribution',
    true,
  )
  const modePriseEnChargeResteModel = setupFieldWithKey<string | null>('financement.modePriseEnChargeReste', true)

  const resteChargeContribution = computed<DropdownItem<string>[]>(() => {
    if (model.value?.typePublic === 'Interimaire') {
      const base =
        model.value?.contrat?.cdiInterimaire === true
          ? ResteChargeContributionTypePublicInterimaireCDI
          : ResteChargeContributionTypePublicInterimaire

      return arrayToDropdownItems(base, ResteChargeContributionLibelle)
    } else {
      return []
    }
  })
</script>
<style lang="less">
  :deep(.input-label) {
    background-color: red;
    flex-shrink: 0 !important;
  }
</style>
